export const constants = {
  get_property_details: '/getPropertyDetails',
  get_listing_details: '/getListingDetails',
  get_market_insights: '/getMarketInsight',
  get_property_data: '/getPropertyData',

  getCompany: '/getCompany',

  prospector_user_creation: '/createUser',
  prospector_account_verification: '/accountVerify',
  prospector_account_activation: '/activateUser',
  prospector_user_login: '/userAuthenticate',
  prospector_user_logout: '/userLogout',
  prospector_social_media_login: '/socialMediaSignIn',
  prospector_validate_login: '/validateLogin',
  prospector_verify_email: '/verifyEmail',

  prospector_get_users: '/users',
  prospector_update_lead_status: '/updateLeadStatus',
  prospector_my_listings: '/my-listings',
  prospector_my_home_details: '/myHomeDetails',
  prospector_list_property: '/notifyListMyHome',
  multiUploadData: '/multiUploadData',
  uploadData: '/uploadData',
  prospector_resetLink: '/getResetLink',
  prospector_verifyResetLink: '/verifyResetLink',
  prospector_sendMessage: '/sendMessage',
  prospector_updatePassword: '/updatePasswordViaLink',
  prospector_listing_leads: '/listing-leads',
  prospector_listing_get_packages: '/listing-packages',

  listing_checkout_get_token: '/oauth2/token',
  listing_checkout_get_packages: '/checkout/package',
  listing_checkout_get_municipality: '/checkout/muni',
  listing_checkout_create_account: '/checkout/createAccount',
  listing_checkout_submit_data: '/checkout/submit',
  listing_checkout_get_order_info: '/order/info',
  update_activity_log: '/userActivity',

  stripe_checkout: '/checkout-session',

  reset_password_messageId: 'HOMERISER_PASSWORD_RESET',
  reset_password_subject: 'Password Reset',
  reset_password_from: 'passwordreset@homerise.com',
  reset_password_fromName: 'Password Reset',
  reset_password_messageClass: 'PASSWORD_RESET',

  verify_email_messageId: 'HOMERISER_EMAIL_VERIFICATION',
  verify_email_subject: 'HomeRise Email Verification',
  verify_email_from: 'verificationemail@homerise.com',
  verify_email_fromName: 'Verify Email Address',
  verify_email_messageClass: 'VERIFY_EMAIL',

  COMPANY: {
    "prospektr": {
      "name": "Prospektr",
      "favicon": "assets/images/favicon.png"
    }
  },
};
